module.exports = __webpack_public_path__ + "img/172.f4bed05a.jpg";